interface SidebarKeyItem {
  base_href: string
  label: string
  subItems?: readonly unknown[]
}

interface SidebarKeySubItem {
  base_href: string
  label: string
}

const buildSidebarNavKey = (
  prefix: "item" | "section" | "subitem",
  baseHref: string | undefined,
  label: string,
) => `${prefix}:${baseHref ?? label}`

export const getSidebarItemKey = (item: SidebarKeyItem) =>
  buildSidebarNavKey(
    item.subItems?.length ? "section" : "item",
    item.base_href,
    item.label,
  )

export const getSidebarSubItemKey = (subItem: SidebarKeySubItem) =>
  buildSidebarNavKey("subitem", subItem.base_href, subItem.label)
